export const COVER_PAGE_INLINE_EDITOR_SOFT_STYLES = {
  borderWidth: "1px",
  borderColor: "blackAlpha.100",
  borderRadius: "card",
  boxShadow: "none",
  bg: "transparent",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  "&:focus-within": {
    borderColor: "blackAlpha.400",
    boxShadow: "0 0 0 1px rgba(45, 55, 72, 0.14)"
  },
  "& .ProseMirror": {
    color: "PRIMARY_GRAY",
    lineHeight: 1.6,
    paddingInline: "16px",
    paddingBlock: "14px",
    borderRadius: "var(--chakra-radii-card)",
  },
  "& .ProseMirror p": {
    margin: "0 0 0.75em"
  },
  "& .ProseMirror p:last-of-type": {
    marginBottom: "0"
  }
} as const

export const COVER_PAGE_INLINE_EDITOR_SOFT_STYLES_SPACIOUS = {
  ...COVER_PAGE_INLINE_EDITOR_SOFT_STYLES,
  "& .ProseMirror": {
    ...COVER_PAGE_INLINE_EDITOR_SOFT_STYLES["& .ProseMirror"],
    paddingInline: "18px",
    paddingBlock: "16px",
  }
} as const
